import React from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import Dialog from '../Dialog'
import $t from 'i18n'
import { useDispatch } from 'react-redux'
import Actions from 'actions'
import routes from 'consts/routes'
import { history } from '../../../store'
import { SUPPORT_LINK } from 'consts'
import loginService from 'services/loginService'

const ContactUsBtn = () => {
  return (
    <Button
      onClick={() => history.push(SUPPORT_LINK)}
      className='dialog-action'
      type='primary'
    >
      {$t('dialogs.systemError.contactUs')}
    </Button>
  )
}

const BackHomeBtn = () => {
  const dispatch = useDispatch()
  return (
    <Button
      className='dialog-action'
      onClick={() => {
        dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
        dispatch(Actions.createAction(Actions.SYSTEM_ERROR_MODAL_CLOSED))
        loginService.clearTokens()
      }}
      type='outline'
    >
      {$t('dialogs.systemError.backHome')}
    </Button>
  )
}

const ErrorModal = () => {
  const dispatch = useDispatch()
  const shouldShowErrorModal = useSelector(
    state => state.app.shouldShowErrorModal
  )

  const closeModal = () => {
    dispatch(Actions.createAction(Actions.SYSTEM_ERROR_MODAL_CLOSED))
  }

  return (
    <Dialog
      isVisible={shouldShowErrorModal}
      className='system-error-dialog'
      footerActions={[<ContactUsBtn />, <BackHomeBtn />]}
      onCancel={closeModal}
    >
      <div className='system-error-dialog-content'>
        <div className='system-error-dialog-subtitle subtitle'>
          {$t('dialogs.systemError.description')}
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorModal
